import "./index.css";
// src/ArtifactThumbnailContainer/ArtifactThumbnail.tsx
import Container from "@cloudscape-design/components/container";

// src/ArtifactThumbnailContainer/ArtifactThumbnail.module.scss
var ArtifactThumbnail_module_default = {
  content: "ArtifactThumbnail_module_content",
  deliverableLayout: "ArtifactThumbnail_module_deliverableLayout",
  previewContainer: "ArtifactThumbnail_module_previewContainer",
  nonInteractive: "ArtifactThumbnail_module_nonInteractive",
  previewContent: "ArtifactThumbnail_module_previewContent",
  leftColumn: "ArtifactThumbnail_module_leftColumn",
  rightColumn: "ArtifactThumbnail_module_rightColumn",
  artifactHeader: "ArtifactThumbnail_module_artifactHeader",
  artifactTitle: "ArtifactThumbnail_module_artifactTitle",
  subtitle: "ArtifactThumbnail_module_subtitle"
};

// src/ArtifactThumbnailContainer/ArtifactThumbnail.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ArtifactThumbnailContainer = ({ title, subtitle, artifactContent, onClick }) => {
  const handleKeyDown = onClick ? (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  } : void 0;
  const interactiveProps = onClick ? {
    onClick,
    onKeyDown: handleKeyDown,
    role: "button",
    tabIndex: 0
  } : {};
  const layoutClassName = onClick ? ArtifactThumbnail_module_default.deliverableLayout : `${ArtifactThumbnail_module_default.deliverableLayout} ${ArtifactThumbnail_module_default.nonInteractive}`;
  return /* @__PURE__ */ jsx(Container, { disableContentPaddings: true, children: /* @__PURE__ */ jsx("div", { className: ArtifactThumbnail_module_default.content, children: /* @__PURE__ */ jsxs("div", { className: layoutClassName, ...interactiveProps, children: [
    /* @__PURE__ */ jsx("div", { className: ArtifactThumbnail_module_default.leftColumn, children: /* @__PURE__ */ jsxs("div", { className: ArtifactThumbnail_module_default.artifactHeader, children: [
      /* @__PURE__ */ jsx("div", { className: ArtifactThumbnail_module_default.artifactTitle, children: title }),
      subtitle && /* @__PURE__ */ jsx("div", { className: ArtifactThumbnail_module_default.subtitle, children: subtitle })
    ] }) }),
    /* @__PURE__ */ jsx("div", { className: ArtifactThumbnail_module_default.rightColumn, children: /* @__PURE__ */ jsx("div", { className: ArtifactThumbnail_module_default.previewContainer, "aria-hidden": "true", ...{ inert: "" }, children: /* @__PURE__ */ jsx("div", { className: ArtifactThumbnail_module_default.previewContent, children: artifactContent }) }) })
  ] }) }) });
};
export {
  ArtifactThumbnailContainer
};
//# sourceMappingURL=index.js.map
